import { BrowserModule, Title } from '@angular/platform-browser'; 
import { LOCALE_ID, NgModule } from '@angular/core'; 
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { AppRoutingModule } from './app-routing.module'; 
import { AppComponent } from './app.component'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'; 
import { InterceptorService } from './services/interceptor-service.service';
import { PoModule } from '@po-ui/ng-components';
import { RouterModule } from '@angular/router';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { FlinkTitleStrategy } from './services/flink-title-strategy.service';

registerLocaleData(localePt, 'pt-BR');

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        RouterModule,
        PoTemplatesModule,
        BrowserAnimationsModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
        {
            provide: TitleStrategy,
            useClass: FlinkTitleStrategy,
        },
        Title,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        provideHttpClient(withInterceptorsFromDi())
    ] }) 
export class AppModule { }
